import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  IRawMaterial,
  MaterialImportWithWarehousesDto,
  CreateRawMaterialDto,
  UpdateRawMaterialDto,
} from 'shared';
import apiClient from '../api/client';

export function useMaterials() {
  const queryClient = useQueryClient();

  const listQuery = useQuery({
    queryKey: ['materials'],
    queryFn: async () => {
      const { data } = await apiClient.get<IRawMaterial[]>('/materials');
      return data;
    },
  });

  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: ['materials'] });
  };

  const createMutation = useMutation({
    mutationFn: (dto: CreateRawMaterialDto) => apiClient.post<IRawMaterial>('/materials', dto),
    onSuccess: refresh,
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateRawMaterialDto }) =>
      apiClient.put(`/materials/${id}`, data),
    onSuccess: refresh,
  });

  const deleteMutation = useMutation({
    mutationFn: (id: string) => apiClient.delete(`/materials/${id}`),
    onSuccess: refresh,
  });

  const importMutation = useMutation({
    mutationFn: (dto: MaterialImportWithWarehousesDto) =>
      apiClient.post('/materials/import/multi-warehouse', dto),
    onSuccess: refresh,
  });

  return {
    listQuery,
    createMutation,
    updateMutation,
    deleteMutation,
    importMutation,
  };
}
